'use strict';

angular.module('shiftTraderApp')
    .directive('saAvailabilitySet', function () {
      return {
        templateUrl: 'views/directives/saAvailabilitySet.html',
        restrict: 'A',
        scope: {
          availabilitySet: '=saAvailabilitySet',
          fullDayLabel: '@',
          showSummary: '@',
          eventIdentifier: '@',
          editable: '@',
          showTarget: '@'
        },
        link: function postLink(scope, element, attrs) {
          scope.availabilityByDay = {};
          scope.availByDayOfWeek = [[], [], [], [], [], [], []];
          scope.useLongLabel = scope.fullDayLabel === 'true' || scope.fullDayLabel === true;
          scope.isEditable = scope.editable === 'true' || scope.editable === true;

          scope.showTargetHours = scope.showTarget === 'true' || scope.showTarget === true;

          var observeDeregFn = attrs.$observe('showTarget', function(val) {
          // observe 'showTarget' so that, just in case permissions call is async that is being interpolated into 'showTarget' at the level above,
          //   we can handle the watch changing from 'undefined' to true or false

            scope.showTargetHours = val === 'true' || val === true;

            if (!_.isUndefined(val)) {
              observeDeregFn();
            }
          });

          var calculateAvailByDayOfWeek = function() {
            scope.preferredHours = 0;
            scope.unavailableHours = 0;

            scope.availabilityByDay = {};
            scope.availByDayOfWeek = [[], [], [], [], [], [], []];

            _.forEach(scope.availabilitySet.availability_rules, function(rule) {
              if (rule.active && rule._type === 'weekly') {
                if (_.has(scope.availabilityByDay, rule.day_of_week)) {
                  //console.log('n) pushing rule ' + rule.id + ' onto ' + rule.day_of_week);
                  scope.availabilityByDay[rule.day_of_week].push(rule);
                } else {
                  //console.log('1) pushing rule ' + rule.id + ' onto ' + rule.day_of_week);
                  scope.availabilityByDay[rule.day_of_week] = [rule];
                }

                // take the length of the interval and add it by avail or not
                if (rule.avail) {
                  scope.preferredHours += rule.range_twix.length('minutes') / 60.0;
                } else {
                  scope.unavailableHours += rule.range_twix.length('minutes') / 60.0;
                }
              }
            }, this);

            _.forEach([0,1,2,3,4,5,6], function(dayNum) {
              if (_.has(scope.availabilityByDay, dayNum)) {
                scope.availByDayOfWeek[dayNum] = scope.availabilityByDay[dayNum];
              }
            });
          };

          calculateAvailByDayOfWeek();
          //scope.$watch('user.availability_rules', function(rules) {
            //console.log('user.availability_rules watch triggered');
          //}, true);

          if (!_.isUndefined(scope.eventIdentifier)) {
            scope.$on('availabilitySet:refresh:' + scope.eventIdentifier, function() {
              calculateAvailByDayOfWeek();
            });
          }

        }
      };
    });
